import { render } from "./small-popup.vue?vue&type=template&id=3b33730f"
import script from "./small-popup.vue?vue&type=script&lang=js"
export * from "./small-popup.vue?vue&type=script&lang=js"
script.render = render

export default script